// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"371":"01d5be73","453":"8faa970c"}[chunkId] + ".chunk.js";
};